import { NATIVE_ATTENDEE_FIELDS } from "./types";

export function NativeFieldsList() {
  return (
    <div className="space-y-3">
      <p className="text-sm font-medium text-foreground">Campos nativos por ingresso</p>
      <div className="space-y-2">
        {NATIVE_ATTENDEE_FIELDS.map((field) => (
          <div
            key={field.id}
            className="flex items-center justify-between gap-3 rounded-[22px] bg-secondary/40 px-4 py-3 select-none"
            aria-disabled
          >
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-foreground">
                {field.label}
                <span className="ml-0.5 text-primary">*</span>
              </p>
              <p className="text-[11px] text-muted-foreground">{field.fieldTypeLabel} · cada ingresso</p>
            </div>
            <span className="shrink-0 text-[11px] text-muted-foreground">Fixo</span>
          </div>
        ))}
      </div>
    </div>
  );
}
